import React, { useMemo, useState } from "react";
import Button from "shared/Button";

import { useSelector } from "react-redux";

import styles from "./ReferralCard.module.scss";
import ReferralImage from "assets/img/coffeeGiftBox.jpg";
import { priceFormatter } from "shared/utility";

const ReferralCard = () => {
    const { referralData } = useSelector((s) => s.account);
    const [hasCopied, setHasCopied] = useState(false);

    const getReward = useMemo(() => {
        return priceFormatter({
            // referral data doesn't have country code, just currency. Currency will default to GB formatting
            price: referralData.credit_reward.amount,
            currency: referralData.credit_reward.currency,
        });
    }, [referralData.credit_reward]);

    const totalGetReward = useMemo(() => {
        return priceFormatter({
            // referral data doesn't have country code, just currency. Currency will default to GB formatting
            price: referralData.credit_reward.amount * referralData.iterations,
            currency: referralData.credit_reward.currency,
        });
    }, [referralData.credit_reward, referralData.iterations]);

    const giveReward = useMemo(() => {
        return priceFormatter({
            // referral data doesn't have country code, just currency. Currency will default to GB formatting
            price: referralData.discount_value.amount,
            currency: referralData.discount_value.currency,
        });
    }, [referralData.discount_value]);

    const totalGiveReward = useMemo(() => {
        return priceFormatter({
            // referral data doesn't have country code, just currency. Currency will default to GB formatting
            price: referralData.discount_value.amount * referralData.iterations,
            currency: referralData.discount_value.currency,
        });
    }, [referralData.discount_value, referralData.iterations]);

    const { code, credit_reward, discount_value } = referralData;

    const iterationCountWord = useMemo(
        () =>
            ({
                2: "two",
                4: "four",
            })[referralData.iterations] || referralData.iterations,
        [referralData.iterations],
    );

    const copyCode = () => {
        navigator.clipboard.writeText(code);
        setHasCopied(true);
    };

    if (!code || !credit_reward?.formatted || !discount_value?.formatted) {
        return null;
    }

    return (
        <section className={styles.referralCard}>
            <img
                className={styles.image}
                src={ReferralImage}
                alt="A Grind gift box of coffee pods, a coffee and a pastry"
            />

            <div className={styles.body}>
                <div className={styles.copy}>
                    <h3>
                        Give {totalGiveReward}. Get {totalGetReward}.
                    </h3>
                    <p>
                        Introduce a friend to Grind and when they use your code,
                        they'll get {giveReward} off their first{" "}
                        {iterationCountWord} subscription orders.
                        <br />
                        <br />
                        We'll also give you {getReward} off your next{" "}
                        {iterationCountWord} subscription orders too!
                        {referralData.iterations > 2 &&
                            " For a limited time only."}
                    </p>
                </div>

                <div className={styles.actions}>
                    <input className={styles.code} value={code} readOnly />
                    <Button
                        size="lg"
                        btnType={hasCopied ? "secondary" : "primary"}
                        className={styles.copyButton}
                        onClick={copyCode}
                    >
                        {hasCopied ? "Copied" : "Copy code"}
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default ReferralCard;
